import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';
import { UpdateTransactionProduct } from 'app/dtos/TransactionProduct/updateTransactionProduct';
import { TransactionProductCreate } from 'app/dtos/TransactionProduct/CreateTransactionProduct';

@Injectable({
  providedIn: 'root'
})
export class TransactionProductService {

  constructor(private httpClientService: HttpClientService) { }


  async transactionProductCreate(transactionProductCreate: TransactionProductCreate) {
    console.log(transactionProductCreate);
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.TransactionProduct
    },
      {
        transactionManagementId: transactionProductCreate.transactionId,
        productId: transactionProductCreate.productId,
        warehouseId: transactionProductCreate.warehouseId,
        productCount: transactionProductCreate.productCount,
        productPrice: transactionProductCreate.productPrice,
        taxId: transactionProductCreate.taxId,
        discountRate: transactionProductCreate.discountRate,
        currencyId: transactionProductCreate.currencyId,
        description: transactionProductCreate.description,
        seriNos: transactionProductCreate.seriNos,
        saleSerialNos: transactionProductCreate.saleSerialNos,
        createTransactionAdditionalFeatureMatching: transactionProductCreate.createTransactionAdditionalFeatureMatching,
        createTransactionProductVariantDtos: transactionProductCreate.createTransactionProductVariantDtos
      });
    return await firstValueFrom(observable);
  }

  async transactionProductById(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionProduct
    }, id);
    return await firstValueFrom(observable);
  }

  async transactionManagementTransactionProductsById(id, kindId?: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionProduct,
      action: "GetByIdTransactionTransactionProducts",
      queryString: `kindId=${kindId}`
    }, id);
    return await firstValueFrom(observable);
  }

  async transactionProductRemove(id) {
    const observable: Observable<any> = this.httpClientService.delete({
      controller: ControllerType.TransactionProduct
    }, id);
    return await firstValueFrom(observable);
  }

  async updateTransactionProduct(updateTransactionProduct: UpdateTransactionProduct) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionProduct
    },
      {
        id: updateTransactionProduct.id,
        productId: updateTransactionProduct.productId,
        warehouseId: updateTransactionProduct.warehouseId,
        productCount: updateTransactionProduct.productCount,
        productPrice: updateTransactionProduct.productPrice,
        taxId: updateTransactionProduct.taxId,
        discountRate: updateTransactionProduct.discountRate,
        currencyId: updateTransactionProduct.currencyId,
        descriptions: updateTransactionProduct.descriptions,
        serialNos: updateTransactionProduct.serialNos,
        updateTransactionAdditionalFeatureMatchings: updateTransactionProduct.updateTransactionAdditionalFeatureMatchings,
        updateTransactionProductVariantDtos: updateTransactionProduct.updateTransactionProductVariantDtos
      });
    return await firstValueFrom(observable);
  }
}